import { Global, Collection } from "@sourceflow-uk/sourceflow-sdk";
import SeoHead from "../../../components/SeoHead";
import MainBanner from "../../../components/MainBanner";
import SimpleContent from "../../../components/SimpleContent";
import { Container } from "reactstrap";
import { Worker, Viewer, SpecialZoomLevel } from "@react-pdf-viewer/core";
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";
import { useRef, useEffect } from "react";

export default function IndividualPage({ global, page }) {
  const defaultLayoutPluginInstance = defaultLayoutPlugin();
  const refContainer = useRef(null);
  useEffect(() => {
    refContainer.current?.scrollIntoView({ behavior: "smooth" ,block: 'end' });
  });
  return (
    <>
      <SeoHead
        page_name={`${page.title} | The global house of tech and transformation recruitment | Lorien`}
        canonical_link={`documents/${page.url_slug}`}
        en_gb={false}
        en_us={true}
      />

      <div className="offset">
        <MainBanner
          global={global}
          pathPrefix={`documents_page.main_banner`}
          customClass={``}
          content={
            <>
              <h1>{page?.title}</h1>
              {page?.banner_content ? (
                <div
                  dangerouslySetInnerHTML={{ __html: page?.banner_content }}
                />
              ) : null}
            </>
          }
          imageURL1={`/site-assets/images/main-banner.jpg`}
          imageALT1={`Main Banner`}
          imageURL2={`/site-assets/images/main-banner-overlay.jpg`}
          imageALT2={`Overlay Main Banner`}
          editableContent={false}
          displayImage1={false}
        />

        <SimpleContent
          global={global}
          pathPrefix={`documents_page.${page.url_slug}.content`}
          customClass={`py-5 lightGreybg`}
          content={
            <>
              {page?.content ? (
                <div dangerouslySetInnerHTML={{ __html: page?.content }} />
              ) : (
                ""
              )}
            </>
          }
          editableText={false}
        />
        
        <div ref={refContainer}>
          {page?.pdf && (
            <Container>
              <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js">
                <div className="ratio ratio-1x1">
                  <Viewer
                    defaultScale={SpecialZoomLevel.ActualSize}
                    fileUrl={page.pdf}
                    plugins={[
                      defaultLayoutPluginInstance,
                    ]}
                  />
                </div>
              </Worker>
            </Container>
          )}
        </div>
      </div>
    </>
  );
}

export async function getStaticProps({ params }) {
  const global = (await Global()).toJson();
  const page = (await Collection("documents_us")).getJsonItem(
    params.url_slug,
    "url_slug"
  );

  return {
    props: {
      global,
      page,
    },
  };
}

export async function getStaticPaths() {
  const pagePaths = (await Collection("documents_us")).getPaths("url_slug");
  return {
    paths: pagePaths,
    fallback: false,
  };
}
